import styled from 'styled-components';
import { Navigation } from './Navigation';

export const Sidebar = ({ navToggle }) => {
  return (
    <SidebarStyled navToggle={navToggle}>
      <Navigation />
    </SidebarStyled>
  );
};

const SidebarStyled = styled.div`
  width: 16.3rem;
  position: fixed;
  height: 100vh;
  background: var(--background1);
  background: var(--background2);
  overflow: hidden;
  font-size: 42px;
  z-index: 20;
  transition: all 0.4s ease-in-out;
  /* Desktop: always visible, Mobile: controlled by navToggle */
  transform: translateX(0);

  @media screen and (max-width: 1200px) {
    width: 14rem;
    transform: ${props =>
      props.navToggle ? 'translateX(0)' : 'translateX(-100%)'};
  }
`;
